import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  min-height: 10vh;
  height: 100%;
  background: #e5e5e5;
  overflow: auto;
  padding-bottom: 20px;
`;

export const ContentComponents = styled.div`
  padding: 10px;
  height: 90%;
`;

export const Nav = styled.div`
  width: 100%;
  border-radius: 8px;
  background: #f4f7fe;
`;

export const NavContent = styled.div`
  width: 100%;
  grid-area: navi;
  height: 100%;
  border-radius: 8px;
  background: white;
  display: flex;
  flex-direction: column;
`;
